import { logService } from './LogService';

class UrlService {
    public replaceURIPlaceholders(uri: string, parameters: any) {
        let result = uri;
        if (parameters) {
            Object.keys(parameters).forEach((parameterName: string) => {
                if (this.isValidParameter(parameters[parameterName])) {
                    result = result.replace(
                        '{' + parameterName + '}',
                        (window as any).encodeURIComponent(parameters[parameterName])
                    );
                } else {
                    const msg = 'something went wrong when constructing the request URI.';
                    logService.logError(msg, { uri, parameters });
                }
            });
        }
        return result;
    }

    private isValidParameter(parameter: any) {
        return parameter || parameter === false || parameter === 0;
    }
}

export const urlService = new UrlService();
